import styled from 'styled-components';
import {input as inputList} from '../../../component/input/inputList/InputList.css';
import {ItemText, ItemContent} from '../../../component/item/Item.css';
import {
    WHITE,
    LIGHT_GRAY,
    LIGHT_GRAY5,
    DARK_GRAY,
    VERY_DARK_GRAY,
    STRONG_BLUE,
    LIGHT_BLUE_GRAY,
    dFlexCenter,
    LIGHT_GRAY2,
    ellipsis
} from '../../../globalVariables/GlobalVariables';
import {
    dFlex,
    alignCenter,
    justifyEnd
} from '../../../globalVariables/GlobalFlex';
import {text} from '../../../component/dataItem/DataItem.css';

export const clubFormContainer = styled.div`
    padding: 20px;
    background-color: ${LIGHT_GRAY};
    border-radius: 8px;
    margin: 10px 0;
`;

export const sectionTitle = styled.h3`
    font-size: 18px;
    font-weight: 600;
    color: ${DARK_GRAY};
    margin-block-end: 20px;
    border-bottom: 2px solid ${STRONG_BLUE};
    padding-block-end: 10px;
`;

export const sectionSubtitle = styled.h4`
    font-size: 16px;
    font-weight: 500;
    color: ${VERY_DARK_GRAY};
    margin: 15px 0 10px 0;
`;

export const generalSettings = styled.div`
    background-color: ${WHITE};
    padding: 15px;
    border-radius: 6px;
    margin-block-end: 20px;
    border: 1px solid ${LIGHT_GRAY5};
`;

export const clubsList = styled.div`
    background-color: ${WHITE};
    padding: 15px;
    border-radius: 6px;
    margin-block-end: 20px;
    border: 1px solid ${LIGHT_GRAY5};
`;

export const clubItem = styled.div`
    background-color: ${LIGHT_GRAY};
    padding: 15px;
    border-radius: 6px;
    margin-block-end: 15px;
    border: 1px solid ${LIGHT_BLUE_GRAY};
    border-inline-start: 4px solid ${STRONG_BLUE};
    
    &:last-child {
        margin-block-end: 0;
    }
    
    &:hover {
        background-color: ${LIGHT_GRAY2};
        transition: background-color 0.2s ease;
    }
`;

export const addClubSection = styled.div`
    ${dFlexCenter}
    padding: 15px;
    background-color: ${WHITE};
    border-radius: 6px;
    border: 1px solid ${LIGHT_GRAY5};
`;

export const input = styled.div`
    margin: 5px 0;
    width:200px;
    ${ItemContent}{
        display:none ;
    }
    ${ItemText}{
        padding-inline-start:20px;
        white-space: break-spaces;
        width: 150px;
    }
    ${inputList}{
        line-height:13px ;
    }
    ${text}{
        ${ellipsis}
            width: 70px;
    text-align: center;
    }
`;

export const tokenRow = styled.div`
    ${dFlex}
    ${alignCenter}
    ${justifyEnd}
    width: 100%;
    gap: 12px;
    input {
        background-color: transparent;
        width: 120px;
    }
`;
